import { fromPromise } from 'apollo-link'
import { onError } from 'apollo-link-error'
import { Mutex } from 'async-mutex'
import { TransactionName as AuthTransactionName } from '@/store/modules/authentication'
import { TransactionHeaderName } from '@/store/modules/Transaction'
import axios from 'axios'

const mutex = new Mutex()
let tokenPromise = null
let count = 0

let apolloErrorLoggingOut = false

function handleLogout (vueStore) {
  if (typeof window.logoutClearAuth === 'function') {
    window.logoutClearAuth()
  } else {
    if (!apolloErrorLoggingOut) {
      apolloErrorLoggingOut = true
      if (typeof vueStore !== 'undefined') {
        vueStore.dispatch('removeAuthTokens')
        vueStore.commit('clearMessages', { root: true })
      }
      window.location.href = '/_contao/logout'
    }
  }
}

export function handle401Link (vueStore, autoLogoutMessage, restEndpoint) {
  const getNewToken = (vueStore) => {
    count++ // count calls trying to get a new token
    return mutex.runExclusive(() => {
      const refreshToken = vueStore.getters.refreshToken
      if (refreshToken) {
        if (count === 1) {
          const headers = {}
          vueStore.dispatch('Transaction/createTransactionId', AuthTransactionName)
          headers[TransactionHeaderName] = vueStore.getters['Transaction/transactionIds'][AuthTransactionName]

          tokenPromise = axios.post(restEndpoint + '/api/token', {
            grant_type: 'refresh_token',
            client_id: vueStore.getters.clientId,
            client_secret: vueStore.getters.clientSecret,
            refresh_token: refreshToken
          }, {
            headers
          })
        }
        return tokenPromise
      } else {
        throw new Error('not refresh token')
      }
    })
      .then(function (result) {
        count--
        if (count === 0) tokenPromise = null
        return result.data
      })
      .catch(e => {
        count--
        if (count === 0) tokenPromise = null
        throw e
      })
  }

  return onError(({ graphQLErrors, networkError, operation, forward }) => {
    if (networkError) {
      if (typeof networkError.statusCode === 'undefined') {
        vueStore.commit('clearMessages', { root: true })
        vueStore.commit('addError', new Error('Es ist ein Netzwerk-Fehler aufgetreten'), { root: true })
      } else {
        switch (networkError.statusCode) {
          case 401:
            if (vueStore.getters.accessToken) {
              return fromPromise(
                getNewToken(vueStore).catch(e => {
                  vueStore.dispatch('removeAuthTokens')
                  vueStore.commit('clearMessages', { root: true })
                  vueStore.commit('addError', 'Es ist ein technischer Fehler aufgetreten', { root: true })
                  vueStore.commit('addFlash', autoLogoutMessage, { root: true })
                  handleLogout(vueStore)
                  throw e
                })
              )
                .filter((value) => Boolean(value))
                .flatMap((authTokens) => {
                  vueStore.dispatch('updateAuthTokens', authTokens)
                  const headers = operation.getContext().headers
                  headers.Authorization = `Bearer ${authTokens.access_token}`
                  // modify the operation context with a new token
                  operation.setContext({
                    headers
                  })
                  // retry the request, returning the new observable
                  return forward(operation)
                })
            } else {
              handleLogout(vueStore)
            }
            break
        }
      }
    }
  })
}
